export const initialise = () => {

  angular.module('app.user').config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    ($stateProvider, $urlRouterProvider, $locationProvider) => {
      $locationProvider.hashPrefix('');
      $stateProvider.state('userSchemes', {
        url: '/schemes',
        templateUrl: 'app/angularJS/features/user/schemes/schemes.html',
        controller: 'SchemeController',
        controllerAs: 'vm',
        parent: 'common'
      }).state('userProfile', {
        url: '/profile',
        templateUrl: 'app/angularJS/features/user/profile/profile.html',
        controller: 'UserProfileController',
        controllerAs: 'vm',
        parent: 'common'
      }).state('userSchemes-edit', {
        url: '/schemes/:schemeId/edit',
        templateUrl: 'app/angularJS/features/user/schemes/edit/scheme-edit.html',
        controller: 'SchemeEditController',
        controllerAs: 'vm',
        parent: 'common',
        params: { schemeId: undefined }
      });
      $urlRouterProvider.otherwise('/');
    }]);
};